import React from 'react';
import { Search } from 'lucide-react';
import FilterDropdown from '../common/FilterDropdown';

interface SearchAndFiltersProps {
  searchTerm: string;
  statusFilter: string;
  dateFilter: string;
  customDateFrom?: string;
  customDateTo?: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusFilterChange: (status: string) => void;
  onDateFilterChange: (date: string) => void;
  onCustomDateFromChange?: (date: string) => void;
  onCustomDateToChange?: (date: string) => void;
  onClearFilters: () => void;
  hasActiveFilters: boolean;
}

const SearchAndFilters: React.FC<SearchAndFiltersProps> = ({
	searchTerm,
	statusFilter,
	dateFilter,
	customDateFrom = '',
	customDateTo = '',
	onSearchChange,
	onStatusFilterChange,
	onDateFilterChange,
	onCustomDateFromChange,
	onCustomDateToChange,
	onClearFilters,
	hasActiveFilters,
}) => {
	return (
		<div className="bg-white p-6 rounded-xl shadow-sm mb-6 flex flex-wrap gap-4 items-center">
			<div className="relative flex-1 min-w-[200px]">
				<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
				<input
					type="text"
					value={searchTerm}
					onChange={onSearchChange}
					placeholder="Search by ID or name"
					className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg"
				/>
			</div>
      
			<FilterDropdown
				triggerLabel="Status"
				selectedValue={statusFilter}
				placeholder="All Status"
				options={[
					{ value: 'all', label: 'All Status' },
					{ value: 'verified', label: 'Verified' },
					{ value: 'failed', label: 'Failed' },
					{ value: 'pending', label: 'Pending' }
				]}
				onChange={onStatusFilterChange}
			/>
      
			<FilterDropdown
				triggerLabel="Date Range"
				selectedValue={dateFilter}
				placeholder="All Time"
				options={[
					{ value: 'all', label: 'All Time' },
					{ value: 'today', label: 'Today' },
					{ value: 'week', label: 'This Week' },
					{ value: 'month', label: 'This Month' },
					{ value: 'custom', label: 'Custom Range' }
				]}
				onChange={onDateFilterChange}
			/>

			{/* Custom Date Range Inputs - show only when custom is selected */}
			{dateFilter === 'custom' && (
				<>
					<div className="flex items-center gap-2">
						<label className="text-sm text-gray-600">From:</label>
						<input
							type="date"
							value={customDateFrom}
							onChange={(e) => onCustomDateFromChange?.(e.target.value)}
							className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
						/>
					</div>
					<div className="flex items-center gap-2">
						<label className="text-sm text-gray-600">To:</label>
						<input
							type="date"
							value={customDateTo}
							onChange={(e) => onCustomDateToChange?.(e.target.value)}
							className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
						/>
					</div>
				</>
			)}
      
			{hasActiveFilters && (
				<button onClick={onClearFilters} className="text-gray-600 hover:underline">
          Clear Filters
				</button>
			)}
		</div>
	);
};

export default SearchAndFilters;
